module.exports = __webpack_public_path__ + "static/media/imgLearn_1.239e768f.png";